/**
 * Design Tokens - Main Export
 * Exported from Figma: Enersee Platform 2.0 - _Foundation_DesignSystem
 *
 * Central export point for all design tokens.
 * These tokens ensure design-development parity and should be used
 * consistently across the application.
 *
 * Usage:
 * ```tsx
 * import { tokens } from '@/lib/tokens';
 *
 * // Access tokens
 * const primaryColor = tokens.colors.text.primary;
 * const spacing = tokens.spacing.md;
 * ```
 */

// Combined tokens object for convenience
import { colorTokens } from './colors';
import { spacingTokens } from './spacing';
import { radiusTokens } from './radius';
import { typographyTokens } from './typography';
import { layoutTokens } from './layout';

export { colorTokens } from './colors';
export { spacingTokens } from './spacing';
export { radiusTokens } from './radius';
export { typographyTokens } from './typography';
export { layoutTokens } from './layout';

export * from './colors';
export * from './spacing';
export * from './radius';
export * from './typography';
export * from './layout';

export const tokens = {
  colors: colorTokens,
  spacing: spacingTokens,
  radius: radiusTokens,
  typography: typographyTokens,
  layout: layoutTokens,
} as const;

export type DesignTokens = typeof tokens;
